<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-interactions-compare-metrics-result">
    <div ref="comparisonTable" class="div-talbe">
      <table class="comparison-talbe">
        <tr class="tr-header">
          <th class="with-boder"></th>
          <th class="with-boder">Comparison Period A</th>
          <th class="with-boder">Comparison Period B</th>
          <th colspan="2">Change</th>
        </tr>
        <tr class="tr-header-bottom">
          <td class="col-1"></td>
          <td class="col-2">{{parent.dateRangeDisplayA}}</td>
          <td class="col-3">{{parent.dateRangeDisplayB}}</td>
          <td class="col-4">Value</td>
          <td class="col-5">%</td>
        </tr>
        <tr class="tr-row chat-valume-row selected" @click="handleChatVolume">
          <td class="col-1">Volume</td>
          <td class="col-2">{{dataA.tableData.chatVolumeDMValue ? formatterNumber(dataA.tableData.chatVolumeDMValue) : 'N/A'}}</td>
          <td class="col-3">{{dataB.tableData.chatVolumeDMValue ? formatterNumber(dataB.tableData.chatVolumeDMValue) : 'N/A'}}</td>
          <td class="col-4">
            <div v-if="this.dataB.tableData.chatVolumeDMValue">
              <span :class="(chatVolumeTotalDiff < 0?'percent down':'percent up')">{{formatterNumber(Math.abs(chatVolumeTotalDiff))}}</span>
              <span v-if="chatVolumeTotalDiff != 0" :class="(chatVolumeTotalDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
          <td class="col-5">
            <div v-if="this.dataB.tableData.chatVolumeDMValue">
              <span :class="(chatVolumePercentageDiff < 0?'percent down':'percent up')">{{Math.abs(chatVolumePercentageDiff)}}%</span>
              <span v-if="chatVolumePercentageDiff != 0" :class="(chatVolumePercentageDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
        </tr>
        <tr class="tr-row avg-auto-qm-score-row" @click="handleAvgAutoEvalScore">
          <td class="col-1">Auto Evaluation Score</td>
          <td class="col-2">{{autoEvalScoresA}}</td>
          <td class="col-3">{{autoEvalScoresB}}</td>
          <td class="col-4">
            <div v-if="this.dataB.tableData.autoEvalScore || this.dataB.tableData.autoEvalScore==0">
              <span :class="((this.dataB.tableData.autoEvalScore - this.dataA.tableData.autoEvalScore) < 0?'percent down':'percent up')">{{formatterNumber(Math.abs(autoEvalScoresTotalDiff))}}</span>
              <span v-if="this.dataB.tableData.autoEvalScore - this.dataA.tableData.autoEvalScore != 0" :class="((this.dataB.tableData.autoEvalScore - this.dataA.tableData.autoEvalScore) < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
          <td class="col-5">
            <div v-if="this.dataB.tableData.autoEvalScore || this.dataB.tableData.autoEvalScore==0">
              <span :class="(autoEvalScoresPercentageDiff < 0?'percent down':'percent up')">{{Math.abs(autoEvalScoresPercentageDiff)}}%</span>
              <span v-if="autoEvalScoresPercentageDiff != 0" :class="(autoEvalScoresPercentageDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
        </tr>
        <tr class="tr-row handling-time-row" @click="handleHandingTime">
          <td class="col-1">Call Handle Time</td>
          <td class="col-2">{{handlingTimesA}}</td>
          <td class="col-3">{{handlingTimesB}}</td>
          <td class="col-4">
            <div v-if="this.dataB.tableData.handlingTime || this.dataB.tableData.handlingTime==0">
              <span :class="((this.dataB.tableData.handlingTime - this.dataA.tableData.handlingTime) < 0?'percent down':'percent up')">{{handleTimesTotalDiff}}</span>
              <span v-if="this.dataB.tableData.handlingTime - this.dataA.tableData.handlingTime != 0" :class="((this.dataB.tableData.handlingTime - this.dataA.tableData.handlingTime) < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
          <td class="col-5">
            <div v-if="this.dataB.tableData.handlingTime || this.dataB.tableData.handlingTime==0">
              <span :class="(handleTimesPercentageDiff < 0?'percent down':'percent up')">{{Math.abs(handleTimesPercentageDiff)}}%</span>
              <span v-if="handleTimesPercentageDiff != 0" :class="(handleTimesPercentageDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
        </tr>
        <tr v-if="!isHideResponse" class="tr-row handling-time-row" @click="handleResponseTime">
          <td class="col-1">Agent Response Time</td>
          <td class="col-2">{{responseTimesA}}</td>
          <td class="col-3">{{responseTimesB}}</td>
          <td class="col-4">
            <div v-if="this.dataB.tableData.responseTime || this.dataB.tableData.responseTime==0">
              <span :class="((this.dataB.tableData.responseTime - this.dataA.tableData.responseTime) < 0?'percent down':'percent up')">{{responseTimesTotalDiff}}</span>
              <span v-if="this.dataB.tableData.responseTime - this.dataA.tableData.responseTime != 0" :class="((this.dataB.tableData.responseTime - this.dataA.tableData.responseTime) < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
          <td class="col-5">
            <div v-if="this.dataB.tableData.responseTime || this.dataB.tableData.responseTime==0">
              <span :class="(responseTimesPercentageDiff < 0?'percent down':'percent up')">{{Math.abs(responseTimesPercentageDiff)}}%</span>
              <span v-if="responseTimesPercentageDiff != 0" :class="(responseTimesPercentageDiff < 0?'bottom-right down':'top-right up')"></span>
            </div>
            <div v-else>-</div>
          </td>
        </tr>
        <tr class="tr-row handling-time-row no-hover">
          <td class="col-1">&nbsp;</td>
          <td class="col-2">&nbsp;</td>
          <td class="col-3">&nbsp;</td>
          <td class="col-4">&nbsp;</td>
          <td class="col-5">&nbsp;</td>
        </tr>
        <tr class="tr-row handling-time-row no-hover">
          <td class="col-1">&nbsp;</td>
          <td class="col-2">&nbsp;</td>
          <td class="col-3">&nbsp;</td>
          <td class="col-4">&nbsp;</td>
          <td class="col-5">&nbsp;</td>
        </tr>
        <tr class="tr-row handling-time-row no-hover">
          <td class="col-1">&nbsp;</td>
          <td class="col-2">&nbsp;</td>
          <td class="col-3">&nbsp;</td>
          <td class="col-4">&nbsp;</td>
          <td class="col-5">&nbsp;</td>
        </tr>
        <tr class="tr-row handling-time-row no-hover">
          <td class="col-1">&nbsp;</td>
          <td class="col-2">&nbsp;</td>
          <td class="col-3">&nbsp;</td>
          <td class="col-4">&nbsp;</td>
          <td class="col-5">&nbsp;</td>
        </tr>
      </table>
    </div>
    <div class="div-topic-picker">
      <div class="topic-picker-header">Topics Compared</div>
      <div class="div-selected-topic-content" ref="topicContent">
        <div :title="topic.label" class="div-item" v-for="topic in selectedTopicList" :key="topic.label">
          {{topic.label}}
        </div>
      </div> 
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import WyUtils from '../../../library/wy-utils.js';

export default Vue.extend({
  name: 'wy-interactions-compare-metrics-result',  
  props: ['parent', 'dataA', 'dataB'],
  data() {
    return {
      tableData: {},
      table: null,
      topicContent: null
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'isHideResponse']),

    selectedTopicList() {
      if(this.parent.selecteTopicList) {
        return this.parent.selecteTopicList;
      }
      return [];
    },

    autoEvalScoresA() {
      if(this.dataA.tableData.autoEvalScore > 0) {
        return this.dataA.tableData.autoEvalScore;
      }
      else {
        return 'N/A';
      }
    },

    autoEvalScoresB() {
      if(this.dataB.tableData.autoEvalScore > 0) {
        return this.dataB.tableData.autoEvalScore;
      }
      else {
        return 'N/A';
      }
    },

    handlingTimesA() {
      if(this.dataA.tableData.handlingTime || this.dataA.tableData.handlingTime == 0) {
        return (this.dataA.tableData.handlingTime == 0) ? '0s' : WyUtils.toNiceTimeFormat(this.dataA.tableData.handlingTime*60);
      }
      else {
        return 'N/A';
      }
    },
    handlingTimesB() {
      if(this.dataB.tableData.handlingTime || this.dataB.tableData.handlingTime == 0) {
        return (this.dataB.tableData.handlingTime == 0) ? '0s' : WyUtils.toNiceTimeFormat(this.dataB.tableData.handlingTime*60);
      }
      else {
        return 'N/A';
      }
    },
    responseTimesA() {
      if(this.dataA.tableData.responseTime || this.dataA.tableData.responseTime == 0) {
        return (this.dataA.tableData.responseTime == 0) ? '0s' : WyUtils.toNiceTimeFormat(this.dataA.tableData.responseTime*60);
      }
      else {
        return 'N/A';
      }
    },
    responseTimesB() {
      if(this.dataB.tableData.responseTime || this.dataB.tableData.responseTime == 0) {
        return (this.dataB.tableData.responseTime == 0) ? '0s' : WyUtils.toNiceTimeFormat(this.dataB.tableData.responseTime*60);
      }
      else {
        return 'N/A';
      }
    },

    autoEvalScoresTotalDiff() {
      return this.dataB.tableData.autoEvalScore - this.dataA.tableData.autoEvalScore;
    },
    autoEvalScoresPercentageDiff() {
      return WyUtils.calculatePercentage(this.dataA.tableData.autoEvalScore, this.dataB.tableData.autoEvalScore);
    },
    
    handleTimesTotalDiff() {
      return WyUtils.toNiceTimeFormat(Math.abs(this.dataB.tableData.handlingTime - this.dataA.tableData.handlingTime)*60);
    },
    handleTimesPercentageDiff() {
      return WyUtils.calculatePercentage(this.dataA.tableData.handlingTime, this.dataB.tableData.handlingTime);
    },

    responseTimesTotalDiff() {
      return WyUtils.toNiceTimeFormat(Math.abs(this.dataB.tableData.responseTime - this.dataA.tableData.responseTime)*60);
    },
    responseTimesPercentageDiff() {
      return WyUtils.calculatePercentage(this.dataA.tableData.responseTime, this.dataB.tableData.responseTime);
    },

    chatVolumeTotalDiff() {
      return this.dataB.tableData.chatVolumeDMValue - this.dataA.tableData.chatVolumeDMValue;
    },
    chatTransfersTotalDiff() {
      return this.dataB.tableData.transfers - this.dataA.tableData.transfers;
    },

    chatTransfersPercentageDiff() {
      return WyUtils.calculatePercentage(this.dataA.tableData.transfers, this.dataB.tableData.transfers);
    },
    
    chatVolumePercentageDiff() {
      return WyUtils.calculatePercentage(this.dataA.tableData.chatVolumeDMValue, this.dataB.tableData.chatVolumeDMValue);
    },
  },

  methods: {
    showSection(sectionName) {
      let isShow = true;
      this.dataModel.columns.forEach(column => {
        if(column.name == sectionName) {
          if(column.hide){
            isShow = false;
          }
        }
      });
      if(this.topicContent) {
        this.topicContent.style.height = (this.table.offsetHeight - 73) + "px"
      }
      return isShow;
    },

    handleSelectEvent(e) {
      switch(e.target.nodeName) {
        case 'DIV':
          e.target.parentNode.parentNode.classList.add("selected");
          break;
        case 'SPAN':
          e.target.parentNode.parentNode.parentNode.classList.add("selected");
          break;
        default:
          e.target.parentNode.classList.add("selected");
      }
    },

    handleAvgAutoEvalScore(e) {
      this.removeClassName(e, "selected")
      this.handleSelectEvent(e);
      this.parent.$refs.compareMetricsChart.handleAvgAutoEvalScore();
    },
    
    handleHandingTime(e) {
      this.removeClassName(e, "selected")
      this.handleSelectEvent(e);
      this.parent.$refs.compareMetricsChart.handleHandingTime();
    },

    handleResponseTime(e) {
      this.removeClassName(e, "selected")
      this.handleSelectEvent(e);
      this.parent.$refs.compareMetricsChart.handleResponseTime();
    },

    handleChatVolume(e) {
      this.removeClassName(e, "selected")
      this.handleSelectEvent(e);
      this.parent.$refs.compareMetricsChart.handleChatVolume();
    },

    handleTransfers(e) {
      this.removeClassName(e, "selected")
      this.handleSelectEvent(e);
      this.parent.$refs.compareMetricsChart.handleTransfers();
    },

    formatterNumber(value) {
      return WyUtils.formatterNumber(value);
    },
    removeClassName(e, className) {
      document.querySelectorAll(".tr-row").forEach(el => {
        if((' ' + el.className + ' ').indexOf(' ' + className + ' ') > -1){
          el.classList.remove(className);
        }
      })
    }
  },
  mounted() {
    this.table = this.$refs.comparisonTable;
    this.topicContent = this.$refs.topicContent;
    setTimeout(()=>{
      this.parent.$refs.compareMetricsChart.handleChatVolume();
    },200)
  }
});
</script>

<style lang="scss">
.wy-interactions-compare-metrics-result {
  min-height: 200px;
  padding: 0px 0px 20px 0px;
  margin-bottom: 0px;

  .div-talbe {
    width: 79%;
    display: inline-block;
    margin: 0px 0 0px 0;
    box-shadow: 0px 1px 5px #0000001A;
    border-radius: 10px;
    background-color: #fff;
    opacity: 1;
    padding: 10px 0px 15px 0px;
    // height: 260px;
    height: fit-content;

    .comparison-talbe {
      width: 100%;
      display: inline-table;
      border-spacing: 0px;
      th {
        width: 25%;
        font-weight: 600;
        font-size: 12px;
        text-align: center;
        line-height: 24px;
        color: #002852;
      }
      tr:hover {
        background: #f5f7fa;
        cursor: default;
      } 
      th.with-boder {
        border-right: 1px solid #D5D5D5;
      }
      .tr-header:hover, .tr-header-bottom:hover, .sentiment-positive-row:hover, .sentiment-negative-row:hover{
        background: unset;
      }
      .handling-time-row,.chat-valume-row,.resolution-row,.sentiment-row {
        td {
          cursor: pointer;
        }
      }
      .no-hover {
        td {
          cursor: default;
          background: #fff;
        }
      }
      .selected {
        background: #E2ECF7;
        font-weight: bold;
      }
      .tr-header-bottom td{
        border-bottom: 1px solid #D5D5D5;
      }

      .col-1, .col-2, .col-3 {
        width: 25%;
        font-size: 11px;
        text-align: center;
        line-height: 24px;
        border-right: 1px solid #D5D5D5;
        padding-right: 0px;
        color: #002852;
      }
      .col-1 {
        font-size: 12px !important;
        padding-left: 70px;
        text-align: left;
      }
      .tr-header-bottom{
        .col-2, .col-3, .col-4, .col-5 {
          font-weight: 500;
          text-align: center;
          padding-right: 0px;
          font-size: 11px;
        }
      }
      .col-4 {
        width: 14%;
        border-right: 1px solid #D5D5D5;
      }
      .col-5 {
        width: 12%;
      }
      .col-4, .col-5 {
        font-size: 11px;
        text-align: center;
        line-height: 22px;
      }
      .sentiment-positive-row {
        .col-1 {
          font-size: 9px;
          font-style: italic;
          padding-left: 80px;
        }
      }
      .sentiment-negative-row {
        .col-1 {
          font-size: 9px;
          font-style: italic;
          padding-left: 80px;
        }
      }
    }

    .percent.up {
      margin-left: 0px;
      color: #4448A2;
    }
    .percent.down {
      margin-left: 0px;
      color: #3E6891;
    }
    .bottom-right.down {
      background-image: url("../../../assets/icons/icon_arrow_down.svg");
      color: #3E6891;
      background-size: 100%;
      background-position-x: 1px;
      background-position-y: 3px;
      background-repeat: no-repeat;
      height: 13px;
      width: 13px;
      display: inline-block;
    }
    .top-right.up {
      background-image: url("../../../assets/icons/icon_arrow_up.svg");
      color: #4448A2;
      background-size: 100%;
      background-position-x: 1px;
      background-position-y: 3px;
      background-repeat: no-repeat;
      height: 13px;
      width: 13px;
      display: inline-block;
    }
  }
  .div-topic-picker {
    float: right;
    width: 20%;    
    box-shadow: 0px 1px 5px #0000001A;
    border-radius: 10px;
    background-color: #fff;
    opacity: 1;
    padding-bottom: 10px; 

    .topic-picker-header {
      font-size: 12px;
      line-height: 12px;
      font-weight: 600;
      text-align: center;
      padding-top: 28px;
      padding-bottom: 10px;
      color: #002852;
    }
    .div-selected-topic-content {
      height: 212px;
      overflow-y: auto;
      overflow-x: hidden;
      background-color: #FFF;
      padding: 6px 0px 7px 0px;
      

      .div-item {
        color: #002852;
        font-weight: normal;
        font-size: 11px;
        line-height: 22px;
        padding-left: 15px;
        width: 88%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      // .div-item:hover {
      //   //background: #E2ECF7;
      //   cursor: default;
      // }
      // .div-item:hover .el-icon-error {
      //   display: block; 
      // }
      &::-webkit-scrollbar {
        width: 20px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 160px;
        border: 2px solid transparent;
        border-top: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track {
        background:#fff;
        border-top: 1px solid #CAD2DA;
      }
      &::-webkit-scrollbar:vertical {
        width: 14px;
      }
      &::-webkit-scrollbar-thumb:vertical {
        border-radius: 160px;
        border: 2px solid transparent;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track:vertical {
        //border-left: 1px solid #CAD2DA;
        border-top: none !important;
      }
    }
  }
}
</style>